import React, { useState } from "react";

const QuestionShort = ({ description }) => {
  return <span className="question-description-short">{description}</span>;
};

export const CreateQuestionShortHeader = ({ data, setData }) => {
  const [title, setTitle] = useState(data.title || "");

  const handleChange = (e) => {
    const { value } = e.target;

    setData((previousState) => ({
      ...previousState,
      title: value,
    }));

    setTitle(value);
  };

  return (
    <input
      type="text"
      name="question-short"
      placeholder="Enter the question here..."
      className="question-input"
      value={title}
      onChange={handleChange}
      autoFocus
    />
  );
};

export const CreateQuestionShortBody = ({ placeholder }) => {
  return (
    <div className="answer-short-body">
      <input
        type="text"
        name="question-short"
        placeholder={placeholder}
        className="answer-input"
        disabled
      />
      <div className="no-buttons"></div>
    </div>
  );
};

export const CreateQuestionShortHeaderNoInput = ({ title }) => {
  return <span className="answer-title">{title}</span>;
};

export default QuestionShort;
